const WaitingIcon = ({ ...props }) => (
	<svg
		{...props}
		width="20"
		height="20"
		viewBox="0 0 11 11"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_304_340)">
			<path
				d="M1.71664 5.23947C1.71664 7.46072 3.51733 9.2614 5.73858 9.2614C7.95984 9.2614 9.76052 7.46072 9.76052 5.23947C9.76052 3.01821 7.95984 1.21753 5.73858 1.21753C3.51733 1.21753 1.71664 3.01821 1.71664 5.23947Z"
				stroke="#FFDF36"
				strokeWidth="0.804388"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.49936 2.89371H4.97907C4.09692 2.89371 4.02888 3.6867 4.50515 4.11839L6.97328 6.36129C7.44954 6.79298 7.38151 7.58597 6.49936 7.58597H4.97907C4.09692 7.58597 4.02888 6.79298 4.50515 6.36129L6.97328 4.11839C7.44954 3.6867 7.38151 2.89371 6.49936 2.89371Z"
				stroke="#FFDF36"
				strokeWidth="0.804388"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_304_340">
				<rect
					width="9.65265"
					height="9.65265"
					fill="white"
					transform="translate(0.912262 0.413147)"
				/>
			</clipPath>
		</defs>
	</svg>
)

export default WaitingIcon
